module.exports = __webpack_public_path__ + "media/assets/images/blog/POST-21GENNAIO-25-85e201750efb04e6ec38992eaf09696f.png";